/*
 * @Author: your name
 * @Date: 2022-03-02 23:31:00
 * @LastEditTime: 2022-03-09 19:37:44
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\pages\function\qrcode\locales.ts
 */
export const EnumPageMeta: IEnumPageMeta = {
    /** 页面名称 */
    title: "",
    // layout: null,
    login: false
}
/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {

}

export default {
    en: {

    },
    zh: {

    }
}
